import { GridDetailsPanelColumnDef } from 'utils/components/GridDetailsPanel/gridDetailsPanelColumnDef';
import { SymbolEventColumn } from 'widgets/corpActions/widget/grid/columnDefinitions';

const domicileChange: GridDetailsPanelColumnDef<SymbolEventColumn>[] = [
    {
        controls: [
            { type: 'field', field: 'oldCountry' },
            { type: 'field', field: 'exDate' },
        ],
    },
    {
        controls: [{ type: 'field', field: 'newCountry' }],
    },
];

export default domicileChange;
